module.exports = "\n.labels {\n  color: rgba(0, 0, 0, .5);\n  font-size: 1rem;\n  text-align: left;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dynamic-form-builder/dynamic-form-builder.component.css
// module id = ./src/app/dynamic-form-builder/dynamic-form-builder.component.css
// module chunks = main